module.exports = __webpack_public_path__ + "img/whats-new-7_jp.16a467e.jpg";